var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcScanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.683,
    height: 63.4,
    viewBox: "0 0 68.683 63.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(11150.424 -1498.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M20.09,12.2V0H2.152A2.147,2.147,0,0,0,0,2.152V43.767a2.147,2.147,0,0,0,2.152,2.152H32.287a2.147,2.147,0,0,0,2.152-2.152V14.35h-12.2A2.159,2.159,0,0,1,20.09,12.2Zm5.74,21.166a1.079,1.079,0,0,1-1.076,1.076H9.686A1.079,1.079,0,0,1,8.61,33.363v-.717A1.079,1.079,0,0,1,9.686,31.57H24.753a1.079,1.079,0,0,1,1.076,1.076Zm0-5.74A1.079,1.079,0,0,1,24.753,28.7H9.686A1.079,1.079,0,0,1,8.61,27.623v-.717A1.079,1.079,0,0,1,9.686,25.83H24.753a1.079,1.079,0,0,1,1.076,1.076Zm0-6.457v.717a1.079,1.079,0,0,1-1.076,1.076H9.686A1.079,1.079,0,0,1,8.61,21.883v-.717A1.079,1.079,0,0,1,9.686,20.09H24.753A1.079,1.079,0,0,1,25.83,21.166Zm8.61-10.233v.547H22.96V0h.547a2.151,2.151,0,0,1,1.525.628l8.78,8.789A2.146,2.146,0,0,1,34.439,10.933Z",
    transform: "translate(-11133.301 1506.888)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-qr-scanner",
    "data-name": "Icon ionic-ios-qr-scanner",
    transform: "translate(-11150.424 1498.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M24.178,4.5H14.47a11.1,11.1,0,0,0-11.1,11.1V25.3A2.311,2.311,0,0,0,8,25.3V15.43A6.336,6.336,0,0,1,9.93,11.1,6.3,6.3,0,0,1,14.3,9.123h9.873a2.311,2.311,0,1,0,0-4.623Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M34.966,4.5H25.093a2.311,2.311,0,1,0,0,4.623h9.873A6.3,6.3,0,0,1,39.341,11.1a6.336,6.336,0,0,1,1.932,4.326V25.3a2.311,2.311,0,0,0,4.623,0V15.43A10.943,10.943,0,0,0,34.966,4.5Z",
    transform: "translate(22.788 -4.5)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M24.178,40.148H14.3A6.3,6.3,0,0,1,9.93,38.167,6.335,6.335,0,0,1,8,33.841V23.968a2.311,2.311,0,0,0-4.623,0v9.873A10.943,10.943,0,0,0,14.3,44.771h9.873a2.311,2.311,0,0,0,0-4.623Z",
    transform: "translate(-3.375 18.629)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M43.584,21.656a2.318,2.318,0,0,0-2.311,2.311v9.873a6.721,6.721,0,0,1-6.307,6.307H25.093a2.311,2.311,0,0,0,0,4.623H34.8a11.108,11.108,0,0,0,11.1-11.1V23.968A2.318,2.318,0,0,0,43.584,21.656Z",
    transform: "translate(22.788 18.629)",
    fill: "#f26122"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScanning);
export default __webpack_public_path__ + "static/media/ic-scanning.8ca89046.svg";
export { ForwardRef as ReactComponent };